import { format, isToday, isYesterday } from "date-fns";
import { cs } from "date-fns/locale";
import { parseDate } from "web_myplann/Shared/Utils/parseDate";

export const formatChatDayLabel = (
	date: Date,
	todayLabel: string,
	yesterdayLabel: string,
): string => {
	if (isToday(date)) return todayLabel;
	if (isYesterday(date)) return yesterdayLabel;
	const label = format(date, "EEEE d. M.", { locale: cs });
	return label.charAt(0).toUpperCase() + label.slice(1);
};

export const formatChatTime = (date: Date): string => format(date, "H:mm");

export const formatChatListTimestamp = (createdAt: string): string => {
	const date = parseDate(createdAt);
	if (!date) return createdAt;
	if (isToday(date)) return format(date, "H:mm");
	return format(date, "d. M.");
};
